import { Action } from '../../types/Action';
import { OnboardingStatus } from "@enums/digital-audience/OnboardingStatus";


export enum DigitalAudienceActionsType {
  SET_DIGITAL_AUDIENCE_ONBOARDING_STATUS = 'Set digital audience onboarding status',
  SET_DIGITAL_AUDIENCE_ONBOARDING_STATUS_FETCHED = 'Set digital audience onboarding fetch status',
}
export const setDigitalAudienceOnBoardingStatus = (status: OnboardingStatus): Action => ({
  type: DigitalAudienceActionsType.SET_DIGITAL_AUDIENCE_ONBOARDING_STATUS,
  payload: { onboardingStatus: status }
});

export const setDigitalAudienceOnBoardingStatusFetched = (isOnboardingStatusFetched: boolean | null): Action => ({
  type: DigitalAudienceActionsType.SET_DIGITAL_AUDIENCE_ONBOARDING_STATUS_FETCHED,
  payload: { isOnboardingStatusFetched: isOnboardingStatusFetched }
});

export type DigitalAudienceActions = ReturnType<
  | typeof setDigitalAudienceOnBoardingStatus
  | typeof setDigitalAudienceOnBoardingStatusFetched
>;